module.exports = __webpack_public_path__ + "static/img/login icon.cd485402.png";